import type { SVGProps } from 'react';

const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg version="1.1" id="Vrstva_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 57.73 57.5" {...props}>
    <g fill='#fff'>
      <g>
        <path className="st0" d="M21.73,26.45H7.43c-2.95,0-5.34-2.4-5.34-5.34V6.81c0-2.95,2.4-5.34,5.34-5.34h14.29
          c2.95,0,5.34,2.4,5.34,5.34v14.29C27.07,24.05,24.67,26.45,21.73,26.45z M7.43,4.43c-1.31,0-2.38,1.07-2.38,2.38v14.29
          c0,1.31,1.07,2.38,2.38,2.38h14.29c1.31,0,2.38-1.07,2.38-2.38V6.81c0-1.31-1.07-2.38-2.38-2.38H7.43z"/>
      </g>
      <g>
        <path className="st0" d="M50.3,26.45H36.01c-2.95,0-5.34-2.4-5.34-5.34V6.81c0-2.95,2.4-5.34,5.34-5.34H50.3
          c2.95,0,5.34,2.4,5.34,5.34v14.29C55.64,24.05,53.25,26.45,50.3,26.45z M36.01,4.43c-1.31,0-2.38,1.07-2.38,2.38v14.29
          c0,1.31,1.07,2.38,2.38,2.38H50.3c1.31,0,2.38-1.07,2.38-2.38V6.81c0-1.31-1.07-2.38-2.38-2.38H36.01z"/>
      </g>
      <g>
        <path className="st0" d="M21.73,54.36H7.43c-2.95,0-5.34-2.4-5.34-5.34V34.73c0-2.95,2.4-5.34,5.34-5.34h14.29
          c2.95,0,5.34,2.4,5.34,5.34v14.29C27.07,51.97,24.67,54.36,21.73,54.36z M7.43,32.35c-1.31,0-2.38,1.07-2.38,2.38v14.29
          c0,1.31,1.07,2.38,2.38,2.38h14.29c1.31,0,2.38-1.07,2.38-2.38V34.73c0-1.31-1.07-2.38-2.38-2.38H7.43z"/>
      </g>
      <g>
        <path className="st0" d="M50.3,54.36H36.01c-2.95,0-5.34-2.4-5.34-5.34V34.73c0-2.95,2.4-5.34,5.34-5.34H50.3
          c2.95,0,5.34,2.4,5.34,5.34v14.29C55.64,51.97,53.25,54.36,50.3,54.36z M36.01,32.35c-1.31,0-2.38,1.07-2.38,2.38v14.29
          c0,1.31,1.07,2.38,2.38,2.38H50.3c1.31,0,2.38-1.07,2.38-2.38V34.73c0-1.31-1.07-2.38-2.38-2.38H36.01z"/>
      </g>
    </g>
    <path className="st1" d="M-124.17-22.34"/>
  </svg>
);

export default SvgDashboard;
